import React from 'react';
import { Provider } from '@radix-ui/react-tooltip';

var FaencyProvider = function (_a) {
  var children = _a.children;
  return /*#__PURE__*/React.createElement(Provider, null, children);
};

export { FaencyProvider };
